@if (loaded()) {
  <div class="report-text-block-wrapper">
    <div class="title">
      <hyperkit-typography [variant]="variant">{{ title }}</hyperkit-typography>
    </div>
    <hyperkit-markdown
      [ngStyle]="{ height: height }"
      [md]="value"
    ></hyperkit-markdown>
  </div>
} @else {
  <p>Loading…</p>
}
